var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    viewBox: "0 0 18 16",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H5.8C6.64869 1 7.46263 1.33714 8.06274 1.93726C8.66286 2.53737 9 3.35131 9 4.2V15.4C9 14.7635 8.74714 14.153 8.29706 13.7029C7.84697 13.2529 7.23652 13 6.6 13H1V1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1H12.2C11.3513 1 10.5374 1.33714 9.93726 1.93726C9.33714 2.53737 9 3.35131 9 4.2V15.4C9 14.7635 9.25286 14.153 9.70294 13.7029C10.153 13.2529 10.7635 13 11.4 13H17V1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBook);
export default __webpack_public_path__ + "static/media/open-book.2feff6e69df6db37ce1a32bec72b366e.svg";
export { ForwardRef as ReactComponent };